module.exports = __webpack_public_path__ + "tablesFull.webp?79735841bc26764a58ac08afd6f81cc1";